import React from 'react';
import { string } from 'prop-types'
import {get} from 'lodash';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import {
  metaLoading,
} from '../lib/helpers';
import Loading from './Loading';

class Interests extends React.Component {
  static propTypes = {
    resourcePath: string.isRequired
  }

  state = {
    ...metaLoading,
    interests: [],
    shouldFetch: true
  }

  fetchIfNeeded = () => {
    if (this.state.shouldFetch) {
      this.setState({
        shouldFetch: false,
        meta: { isLoading: true }
      }, this.fetchInterests)
    }
  }

  fetchInterests = () => {
    axios.get(this.props.resourcePath).then((res) => {
      if (res.status == 200 && get(res, 'data')) {
        this.setState({
          interests: res.data['interests'],
          meta: { isLoading: false }
        })
      }
    })
  }

  render() {
    return(
      <Waypoint onEnter={this.fetchIfNeeded}>
        <div className="Interests">
          <Loading isLoading={get(this.state, 'meta.isLoading')}>
            {this.state.interests.map((interest) => {
              return <img key={interest.id} src={interest.icon} width={40} height={40} title={interest.name} className="Interests__icon" />
            })}
            {this.state.interests.length == 0 &&
              <span>-</span>
            }
          </Loading>
        </div>
      </Waypoint>
    )
  }
}

export default Interests
